import { useFeatureSettings } from '@office-start/feature-settings-service';
import { useMemo } from 'react';
/**
 * Enum describing possible RingId value coming from ECS. Ordered by priority.
 */
var RingIDEnum;
(function (RingIDEnum) {
    RingIDEnum[RingIDEnum["TaosDogfood"] = 0] = "TaosDogfood";
    RingIDEnum[RingIDEnum["Dogfood"] = 1] = "Dogfood";
    RingIDEnum[RingIDEnum["Microsoft"] = 2] = "Microsoft";
    RingIDEnum[RingIDEnum["TargetedRelease"] = 3] = "TargetedRelease";
    RingIDEnum[RingIDEnum["WorldWide"] = 4] = "WorldWide";
})(RingIDEnum || (RingIDEnum = {}));
/**
 * Return Feature Settings passed from ECS.
 * @param data
 * @returns
 */
export const useMOSCapabilitiesFeatureSettingsTemp = () => {
    var _a, _b;
    const { data: featureSettings } = useFeatureSettings();
    const ringIdData = (_b = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _a === void 0 ? void 0 : _a.ring) === null || _b === void 0 ? void 0 : _b.value;
    //Use TaosDogfood as default value.
    const ringIdKey = ringIdData && ringIdData in RingIDEnum
        ? ringIdData
        : RingIDEnum[RingIDEnum.TaosDogfood];
    return useMemo(() => {
        //RingIdEnum[<string>] returns index of the string in Enum list
        return {
            ringId: 'Ring' + RingIDEnum[ringIdKey],
        };
    }, [ringIdKey]);
};
//# sourceMappingURL=useMOSCapabilitiesFeatureSettingsTemp.js.map